import React, { useEffect, useRef, useState } from "react";
import { IconButton, Tooltip } from "@mui/material";
import { Edit as IconEdit } from "@mui/icons-material";
import { withSnackbar } from "notistack";

import UiDialog from "components/Custom/UiDialog";
import RadioBtn from "components/Custom/RadioBtn";
import Btn from "components/Custom/Btn";
import Loader from "components/Custom/Loader";
import ExcelGrid from "components/Custom/ExcelGrid";
import TxtRow from "components/Custom/TxtRow";
import { FORMATS, NOTIFY } from "common/config";
import { COLORS } from "common/colors";
import { DEFAULTS } from "common/config";
import {
  LABELS,
  WARNINGS,
  TITLES,
  SUCCESS,
  ERRORS,
  SUB_TITLES,
} from "common/lables";
import { COMMON_JS } from "common/scripts";

import { MASTER_APIs } from "apihandlers/master";
import { DateFunctions } from "common/datefunctions";
import AutoComplete from "components/Custom/AutoComplete";

const TSLedger = (props: any) => {
  const { setDashMenu } = props;

  const chrgeref: any = useRef(null);
  const [loading, setLoading] = useState(true);
  const [isSubmit, setIsSubmit] = useState(false);
  const [rows, setRows] = useState<any>(null);
  const [manageDialog, setManageDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>({});
  const [charges, setCharges] = useState<any[]>([]);
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);

  const columns = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "5%",
      type: "number",
      align: "center",
      headerAlign: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "dateOfPayment",
      name: LABELS.DATE_OF_PAYMENT,
      width: "15%",
      type: "datetime",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "enteredDate",
      name: LABELS.ENTERED_DATE,
      width: "15%",
      type: "datetime",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "paymentAmount",
      type: "number",
      name: LABELS.PAYMENT_AMOUNT,
      width: "10%",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "remark",
      type: "text",
      name: LABELS.REMARK,
      width: "10%",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "expenseName",
      type: "text",
      name: LABELS.EXPENSE_NAME,
      width: "10%",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "referenceNumber",
      name: LABELS.REFERENCE_NO,
      width: "10%",
      type: "text",
      align: "center",
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "isPaymentText",
      name: LABELS.IS_PAYMENT,
      width: "10%",
      type: "dropdown",
      filters: [
        { id: "yes", name: "Yes" },
        { id: "no", name: "No" },
      ],
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "activeStatusText",
      name: LABELS.ACTIVE,
      width: "10%",
      type: "dropdown",
      filters: [
        { id: "yes", name: "Yes" },
        { id: "no", name: "No" },
      ],
      editable: false,
      sortable: true,
      searchable: true,
    },
    {
      key: "options",
      name: LABELS.OPTIONS,
      width: "5%",
      renderCell: (params) => (
        <div className="options">
          <Tooltip title={LABELS.EDIT} placement="bottom">
            <IconButton
              className="iconBtn"
              onClick={() => onEditRow(params.row)}
            >
              <IconEdit />
            </IconButton>
          </Tooltip>
        </div>
      ),
    },
  ];

  useEffect(() => {
    if (loading) {
      getCharges();
    }
  }, [loading]);

  const getCharges = () => {
    const args = { activeStatus: true, minResponse: true };
    MASTER_APIs.getExpenses(args).then((res: any) => {
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        let list = response.records.map((r) => {
          return {
            id: r.id,
            label: r.expenseName,
          };
        });
        setCharges(list);
        getRows();
      }
    });
  };

  const getRows = async () => {
    try {
      const args = {
        pageNo: 1,
        pageLength: DEFAULTS.PAGE_LENGTH,
      };
      const res: any = await MASTER_APIs.getLedgers(args);
      const { status, response } = res;
      if (status === 200) {
        let list = response.records;
        for (let i = 0; i < response.records.length; i++) {
          list[i]["slNo"] = i + 1;
          if (list[i]["activeStatus"]) {
            list[i]["activeStatusText"] = "Yes";
          } else {
            list[i]["activeStatusText"] = "No";
          }
          if (list[i]["isPayment"]) {
            list[i]["isPaymentText"] = "Yes";
          } else {
            list[i]["isPaymentText"] = "No";
          }
        }
        setRows(list);
        setLoading(false);
      }
    } catch (error) {
      console.error("getLedgers:", error);
    }
  };

  const onEditRow = (row: any) => {
    setSelectedRow(row);
    setManageDialog(true);
    console.log("selectedRow:", selectedRow);
  };

  const manageExpense = () => {
    const dateOfPayment = (
      document.getElementById("dateOfPayment") as HTMLInputElement
    ).value.trim();
    const enteredDate = (
      document.getElementById("enteredDate") as HTMLInputElement
    ).value.trim();
    const paymentAmount = (
      document.getElementById("paymentAmount") as HTMLInputElement
    ).value.trim();
    const remark = (
      document.getElementById("remark") as HTMLInputElement
    ).value.trim();
    const referenceNumber = (
      document.getElementById("referenceNumber") as HTMLInputElement
    ).value.trim();
    const chargeId = chrgeref.current.selectedValue.id;
    const mode = document.querySelector(
      'input[name="typeOfPayment"]:checked'
    ) as HTMLInputElement;
    const typeOfPayment = mode ? mode.value : "";
    const payment = document.querySelector(
      'input[name="activeStatus"]:checked'
    ) as HTMLInputElement;
    const isPayment = payment ? payment.value : "";
    const active = document.querySelector(
      'input[name="activeStatus"]:checked'
    ) as HTMLInputElement;
    const selectBtnValue = active ? active.value : "";

    // Validations
    let errors = [];
    if (dateOfPayment === "") {
      errors.push({
        id: "dateOfPayment",
        msg:
          "<span class='bold'>" +
          LABELS.DATE_OF_PAYMENT +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (enteredDate === "") {
      errors.push({
        id: "enteredDate",
        msg:
          "<span class='bold'>" +
          LABELS.ENTERED_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (paymentAmount === "") {
      errors.push({
        id: "paymentAmount",
        msg:
          "<span class='bold'>" +
          LABELS.PAYMENT_AMOUNT +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (remark === "") {
      errors.push({
        id: "remark",
        msg:
          "<span class='bold'>" +
          LABELS.REMARK +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (!selectBtnValue) {
      errors.push({
        id: "selectBtnValue",
        msg:
          "<span class='bold'>" +
          LABELS.ACTIVE_STATUS +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }

    const args = {
      id: selectedRow.id || -1,
      dateOfPayment,
      enteredDate,
      paymentAmount,
      remark,
      referenceNumber,
      chargeId,
      isPayment,
      typeOfPayment: typeOfPayment,
      activeStatus: selectBtnValue.toString(),
    };
    setIsSubmit(true);
    MASTER_APIs.manageLedger(args).then((res) => {
      setIsSubmit(false);
      if (res.status === 200) {
        COMMON_JS.showNotify(props, NOTIFY.SUCCESS, SUCCESS.RECORD_SUCCESS);
        setSelectedRow({});
        setManageDialog(false);
        reloadGrid();
      } else {
        COMMON_JS.showNotify(props, NOTIFY.ERROR, ERRORS.RECORD_FAILED);
      }
    });
  };

  const reloadGrid = () => {
    setRows(null);
    getRows();
  };

  const onAdd = () => {
    setSelectedRow({});
    setManageDialog(true);
  };

  console.log("Page: TS Expense:");

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => setDashMenu(LABELS.HOME)}>{LABELS.MASTERS} </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.TS_LEDGER}</li>
        </ul>
        <h4>{TITLES.TS_LEDGER}</h4>
        <p>{SUB_TITLES.TS_LEDGER}</p>
      </div>

      <div className="grid excelGridWrapper">
        {rows ? (
          <ExcelGrid
            id={LABELS.TS_LEDGER}
            height={window.innerHeight * 0.8}
            cols={columns}
            rows={rows}
            exportOption={true}
            newRowOption={false}
            exportName={LABELS.TS_LEDGER}
            onReload={reloadGrid}
            onAdd={onAdd}
          />
        ) : (
          <div className="flexRowCenter">
            <Loader />
          </div>
        )}
      </div>

      {manageDialog && (
        <UiDialog
          title={
            selectedRow.id
              ? "Edit " + LABELS.TS_LEDGER + ": " + selectedRow.expenseName
              : "Add New " + LABELS.TS_LEDGER
          }
          open={true}
          size={"sm"}
          onClose={() => {
            setManageDialog(false);
            setMandatoryResults([]);
          }}
        >
          <div className="formGroup ">
            <TxtRow
              id={"dateOfPayment"}
              type={"datetime-local"}
              label={LABELS.DATE_OF_PAYMENT}
              defaultValue={
                selectedRow.dateOfPayment
                  ? DateFunctions.getFormatedDate(
                      selectedRow.dateOfPayment,
                      FORMATS.SQL_DATE,
                      FORMATS.SQL_DATE
                    )
                  : DateFunctions.getDate("now", "from", FORMATS.SQL_DATE)
              }
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup ">
            <TxtRow
              id={"enteredDate"}
              type={"datetime-local"}
              label={LABELS.ENTERED_DATE}
              defaultValue={
                selectedRow.enteredDate
                  ? DateFunctions.getFormatedDate(
                      selectedRow.enteredDate,
                      FORMATS.SQL_DATE,
                      FORMATS.SQL_DATE
                    )
                  : DateFunctions.getDate("now", "from", FORMATS.SQL_DATE)
              }
              disabled={isSubmit}
            />
          </div>

          <div className="formGroup ">
            <TxtRow
              id={"paymentAmount"}
              type={"number"}
              label={LABELS.PAYMENT_AMOUNT}
              defaultValue={selectedRow.paymentAmount}
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup  ">
            <label>{LABELS.EXPENSE_NAME}</label>
            <AutoComplete
              list={charges}
              childRef={chrgeref}
              defaultValue={
                selectedRow.expenseId
                  ? {
                      id: selectedRow.expenseId,
                      label: selectedRow.expenseName,
                    }
                  : null
              }
              onChange={(e, v) => {}}
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup">
            <TxtRow
              id={"remark"}
              type={"text"}
              label={LABELS.REMARK}
              defaultValue={selectedRow.remark}
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup">
            <TxtRow
              id={"referenceNumber"}
              type={"number"}
              label={LABELS.REFERENCE_NO}
              defaultValue={selectedRow.referenceNumber}
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup ">
            <label>{LABELS.MODE_OF_EXPENSE}</label>
            <RadioBtn
              list={[
                {
                  id: "CASH",
                  label: LABELS.CASH,
                  value: LABELS.CASH,
                  checked: selectedRow.id
                    ? selectedRow.typeOfPayment === "CASH"
                    : false,
                  disabled: false,
                },
                {
                  id: "BANK",
                  label: LABELS.BANK,
                  value: LABELS.BANK,
                  checked: selectedRow.id
                    ? selectedRow.typeOfPayment === "BANK"
                    : false,
                  disabled: false,
                },
                {
                  id: "UPI",
                  label: LABELS.UPI,
                  value: LABELS.UPI,
                  checked: selectedRow.id
                    ? selectedRow.typeOfPayment === "UPI"
                    : false,
                  disabled: false,
                },
                {
                  id: "CARD",
                  label: LABELS.CARD,
                  value: LABELS.CARD,
                  checked: selectedRow.id
                    ? selectedRow.typeOfPayment === "CARD"
                    : false,
                  disabled: false,
                },
                {
                  id: "NONE",
                  label: LABELS.NONE,
                  value: LABELS.NONE,
                  checked: selectedRow.id
                    ? selectedRow.typeOfPayment === "NONE"
                    : true,
                  disabled: false,
                },
              ]}
              row={true}
              name={"typeOfPayment"}
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup">
            <label>{LABELS.IS_PAYMENT}</label>
            <RadioBtn
              list={[
                {
                  id: "true",
                  value: "true",
                  label: LABELS.YES,
                  checked: selectedRow.id
                    ? selectedRow.isPayment === true
                    : true,
                  disabled: false,
                },
                {
                  id: "false",
                  value: "false",
                  label: LABELS.NO,
                  checked: selectedRow.id
                    ? selectedRow.isPayment === false
                    : false,
                  disabled: false,
                },
              ]}
              row={true}
              name={"isPayment"}
              disabled={isSubmit}
            />
          </div>
          <div className="formGroup">
            <label className="red">
              {LABELS.ACTIVE_STATUS} {<span>*</span>}
            </label>
            <RadioBtn
              list={[
                {
                  id: "true",
                  value: "true",
                  label: LABELS.ACTIVE,
                  checked: selectedRow.id
                    ? selectedRow.activeStatus === true
                    : true,
                  disabled: false,
                },
                {
                  id: "false",
                  value: "false",
                  label: LABELS.INACTIVE,
                  checked: selectedRow.id
                    ? selectedRow.activeStatus === false
                    : false,
                  disabled: false,
                },
              ]}
              row={true}
              name={"activeStatus"}
              disabled={isSubmit}
            />
          </div>
          {/* mandatoryResults */}
          {mandatoryResults.length > 0 && (
            <div className="mandatoryBox">
              <ul>
                {mandatoryResults.map((m) => {
                  return (
                    <li>
                      <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
          <div className="formGroup submitBtnWrapper">
            <div className="flexbtnjustify">
              <Btn
                text={LABELS.CANCEL}
                loading={isSubmit}
                bgColor={COLORS.RELOAD_EXPORT}
                color={COLORS.RELOAD_EXPORT_TEXT}
                onClick={() => {
                  setManageDialog(false);
                  setMandatoryResults([]);
                }}
              />
              <Btn
                text={LABELS.SAVE}
                loading={isSubmit}
                onClick={manageExpense}
                bgColor={COLORS.SAVE_GREEN}
              />
            </div>
          </div>
        </UiDialog>
      )}
    </React.Fragment>
  );
};

export default withSnackbar(TSLedger);
